export const handleSortingWithGrade = (a, b, sortDescriptor) => {
  const { column, direction } = sortDescriptor;
  let first = null;
  let second = null;
  let cmp = null;
  switch (column) {
    case "team_grade":
      first = a.team_grade || 0;
      second = b.team_grade || 0;
      break;
    case "call_purpose":
      first = a.call_purpose;
      second = b.call_purpose;
      break;
    case "grade":
      first = a?.analysis?.call_overall_grade || 0;
      second = b?.analysis?.call_overall_grade || 0;
      break;
    default:
      first = a[column];
      second = b[column];
      break;
  }
  cmp = first < second ? -1 : first > second ? 1 : 0;
  return direction === "descending" ? -cmp : cmp;
};

export const handleSortingWithGradeRepresentatives = (a, b, sortDescriptor) => {
  const { column, direction } = sortDescriptor;
  let first = null;
  let second = null;
  let cmp = null;
  switch (column) {
    case "grade":
      first = a.average_grade || 0;
      second = b.average_grade || 0;
      break;
    case "team_grade":
      first = a.team_grade || 0;
      second = b.team_grade || 0;
      break;
    default:
      first = a[column];
      second = b[column];
      break;
  }
  cmp = first < second ? -1 : first > second ? 1 : 0;
  return direction === "descending" ? -cmp : cmp;
};

export const sortCallsByGrade = (calls) => {
  return calls.sort((a, b) => {
    return handleSortingWithGrade(a, b, { column: "grade", direction: "descending" });
  });
};
